// extracted by mini-css-extract-plugin
export default {"bodyText":"BodyText_bodyText__IIcfv","truncate":"BodyText_truncate__N0lvP"};